<template>
    <div class="form-floating">
        <input ref="phone" type="tel" :value="content" class="tel h-100 form-control" :class="state" v-bind="$attrs" @change="onPhoneChanged" />
        <label :for="$attrs.id">
            <slot />
        </label>
        <slot name="error" />
    </div>
</template>

<script lang="ts">
import intlTelInput, { Iti } from 'intl-tel-input'
import { Component, Model, Prop, Ref, Vue, toNative } from 'vue-facing-decorator'
import Errors from './Errors.vue'

@Component({
    components: {
        Errors,
    },
    inheritAttrs: false,
    emits: ['update:modelValue'],
})
class Phone extends Vue {
    declare $attrs: {
        id?: string
    }

    phone!: Iti

    //value = ''

    @Ref('phone')
    readonly input!: HTMLInputElement

    @Prop({ type: Object, default: () => { } })
    readonly options!: object

    @Prop({ type: Object, default: () => [] })
    readonly errors!: []

    @Prop({ type: String, default: '' })
    readonly state!: string

    content = ''

    @Model({ type: String })
    value!: string

    onPhoneChanged(event) {
        //console.log('Phone changed:', event.target.value, this.phone.getNumber())
        this.value = this.phone.getNumber()
        this.content = event.target.value
    }

    mounted() {
        this.phone = intlTelInput(this.input, {
            initialCountry: 'ng',
            onlyCountries: ['ng'],
            // geoIpLookup: () => fetch('https://ipapi.co/json')
            //     .then((res) => res.json())
            //     .then((data) => data.country_code),
            loadUtils: () => import('intl-tel-input/utils'),
            separateDialCode: true,
            ...this.options,
        })

        this.input.addEventListener('countrychange', (e) => this.onPhoneChanged(e))
        //this.input.addEventListener('change', (e) => this.onPhoneChanged(e))

        document.querySelector('.iti')?.classList.add('bootstrap-tel')
        this.phone.setNumber(this.value)
    }

    updated() {
        this.phone.setNumber(this.value)
    }

    unmounted() {
        this.phone.destroy()
    }
}

export default toNative(Phone)
</script>

<style lang="scss">
@import '@/scss/variables';
$flagsImagePath: 'intl-tel-input/dist/img/';
@import 'intl-tel-input/dist/css/intlTelInput.min.css';


.bootstrap-tel {
    width: 100% !important;
    height: 58px !important;
}

.iti {
    width: 100%;
    z-index: 950;
}

.iti__arrow {
    border: none;
}


html.dark {
    .iti {
        --iti-border-color: var(--bs-primary-dark);
        --iti-dropdown-bg: var(--bs-primary-darker);
        --iti-icon-color: #aaaaaa;
        --iti-hover-color: var(--bs-white);
        color: var(--bs-white);

        & li:hover {
            color: var(--bs-dark)
        }
    }
}
</style>
